import React, { Component } from "react";
import Logo from "../Logo/Logo";
import { ToggleNav, Modal, BackDrop } from "../UI/index";
import NavItems from "./NavItems/NavItems";
import NavItem from "./NavItems/NavItem/NavItem";
import classes from "./Nav.module.css";

class Nav extends Component {
  state = {
    showModal: false,
  };

  showModalHundler = () => {
    this.setState({ showModal: true });
  };

  closeModalHundler = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      <nav className={classes.Nav}>
        <Logo />
        <div className={classes.NavList}>
          <NavItems />
        </div>
        <ToggleNav
          openModal={this.showModalHundler}
          show={this.state.showModal}
        />
        <Modal
          show={this.state.showModal}
          closeModal={this.closeModalHundler}
        />
        <BackDrop
          show={this.state.showModal}
          clicked={this.closeModalHundler}
        />

        <div className={classes.NavBtn}>
          <NavItem link="/">Contact us</NavItem>
        </div>
      </nav>
    );
  }
}

export default Nav;
